module.exports = __webpack_public_path__ + "static/media/c6.979e3672.png";